import { logError } from '~/utils/log-error'
import { getAdaptedSummaryTable } from '@/utils/adapters'

export default {
  data() {
    return {
      loading: true,
      summary: null,
      priceSummary: null,
      pricesSummaryPortal: null,
      priceIndex: null,
      articles: [],
      reports: [],
    }
  },
  methods: {
    formattedIndexes(indexes) {
      return {
        detailed: indexes.detail,
        summary: indexes.summary.map((summary) => ({
          product: summary.product,
          order: summary.order,
          updateFrequency: summary.updateFrequency,
          data: {
            today: { value: summary.data.today, unit: 'index' },
            last: { value: summary.data.last, unit: 'index' },
            latestChange: summary.data.latestChange,
            yearToDate: summary.data.yearToDate,
            yearOnYear: summary.data.yearOnYear,
          },
        })),
      }
    },
    async getSummaryData() {
      if (!this.category) return
      try {
        const response = await this.$restClient.getPricesConsolidatedByMineral(
          this.category,
        )
        if (response.summary) {
          this.pricesSummaryPortal = getAdaptedSummaryTable({
            summaries: response.summary,
            authorized: response.authorized,
          })
        }
        if (response.indexes) {
          this.priceIndex = this.formattedIndexes(response.indexes)
        } else {
          this.priceIndex = {}
        }
      } catch (error) {
        logError(error)
      }
    },
  },
}
